<template>
	<section class="section-app">
		<section-head
			title="The ship"
			description="Take a look and familiarize yourself with the ship and cabin layout."
			description2="Click BOOK NOW below to view available cabins!"
		/>

		<div class="viewer-wrapper">
			<viewer :options="options" :images="images"
				@inited="inited"
				class="viewer" ref="viewer"
				>
				<template slot-scope="scope">
					<img v-for="src in scope.images" :src="src" :key="src">
				</template>
			</viewer>
		</div><!-- /.viewer-wrapper -->

		<div class="pricing" v-if="pricingImg && pricingImgText">
			<a
				href="#"
				class="pricing__btn"
				@click.prevent="isToggled = !isToggled"
			>
				<span>
					{{ isToggled ? '-' : '+'}}
				</span>

				<strong>{{ pricingImgText }}</strong>
			</a>

			<div class="pricing__image" v-if="isToggled">
				<img :src="pricingImg" alt="">
			</div><!-- /.pricing__image -->
		</div><!-- /.pricing -->

		<div class="section__foot">
			<button
				class="btn btn-blue"
				@click="handleNextClick"
			>
				BOOK NOW
			</button>
		</div><!-- /.section__foot -->
	</section>
</template>

<script>
import Vue from 'vue';
import 'viewerjs/dist/viewer.css';
import Viewer from "v-viewer/src/component.vue"

/**
 * internal dependencies
 */
import { mapActions } from 'vuex';
import SectionHead from '../components/SectionHead.vue'

export default {
	/**
	 * Component Name.
	 *
	 * @type {String}
	 */
	name: 'cruise-overview',

	components:{ SectionHead, Viewer },

	data() {
		return {
			isToggled: false,
			pricingImgText: crb_app.app_data.pricing_img_text,
			pricingImg: crb_app.app_data.pricing_img,
			mainImg: crb_app.app_data.ship_main,
			images: [ pdf_object.cruise_image_url ],
			'options': { "inline": true,
				"button": true,
				"navbar": false,
				"title": false,
				"toolbar": true,
				"tooltip": false,
				"movable": true,
				"zoomable": true,
				"rotatable": false,
				"scalable": true,
				"transition": true,
				"fullscreen": false,
				"keyboard": true,
				"minZoomRatio": 0.04,
				"url": "data-source"
			}
		};
	},

	methods:{
		/**
		 * Map the store's actions.
		 */
		...mapActions([
			'completeStep',
		]),

		handleNextClick() {
			this.completeStep({
				step: 'overview'
			});

			this.$router.push({name:'cruise.passengers'})
		},

		inited (viewer) {
			this.$viewer = viewer
		},
	},

	mounted(){
		this.$viewer.show();
	}
}
</script>

<style type="text/css" media="screen">
	.pricing  { text-align: center;  padding: 30px 0 0; }
	.pricing .pricing__image {text-align: center; max-width: 800px; padding: 25px 0 20px; }
	.pricing .pricing__btn { font-size: 18px; color: #9d9c9a; font-weight: 700; line-height: 1; }
	.pricing .pricing__btn:hover { text-decoration: none;  }
	.pricing .pricing__btn strong { border-bottom: 2px solid #9d9c9a; position: relative; top: -5px;  }
	.pricing .pricing__btn span { text-decoration: none; display: inline-block; width: 34px; height: 34px; border-radius: 50%; border: 2px solid #9d9c9a; line-height: 28px; text-align: center;  font-weight: 700; color: #9d9c9a; font-size: 24px; }
</style>


// WEBPACK FOOTER //
// src/pages/CruiseOverview.vue